import React from 'react';

const WarningMessage = ({ text }) => {
  return (
    <div className="settings-text-helper warning-message">
      <p>⚠️ {text}</p>
    </div>
  );
};

export default WarningMessage;
